import { MESSAGE_TYPES } from '@zg-rentals/satellite-components';
import type { OnSystemMessageCtaClickArgs } from '../../MessageItem';

export function handleSystemMessageCtaClick(
  { messageType, url }: OnSystemMessageCtaClickArgs,
  openRenterDetailsDrawer: () => void,
  leadManagementPath?: string,
): void {
  if (
    messageType === MESSAGE_TYPES.RENTER_PROFILE_SUBMISSION ||
    (leadManagementPath && url?.includes(leadManagementPath))
  ) {
    openRenterDetailsDrawer();
    return;
  }

  if (url) {
    window.open(url, '_blank');
  }
}
